// extracted by mini-css-extract-plugin
module.exports = {"gameWrapper":"_bd0d1de","backdrop":"_77bdc7f","close":"_83fad41","game":"_726a011","gameIframe":"_843712b"};